var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tag-input/~/lodash/_Symbol.js
 ** module id = 1122
 ** module chunks = 0
 **/